import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { BaseSocialLoginButton } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/BaseSocialLoginButton";
import { extractMessage } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/errorMessages";
import { useHandleSSOSuccess } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/useHandleSSOSuccess";
import { useScriptCheck } from "@faire/retailer-visitor-shared/components/SocialSignOnButtons/useScriptCheck";
import { initializeAppleLogin, isAppleLoginInitialized } from "@faire/retailer-visitor-shared/initializers/initializeAppleLogin";
import { useSSOErrorStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOErrorStore";
import { useSSOStore } from "@faire/retailer-visitor-shared/stores/domain/SSO/useSSOStore";
import { getDocumentOrThrow } from "@faire/web--source/common/globals/getDocument";
import { getWindowOrThrow } from "@faire/web--source/common/globals/getWindow";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { logError } from "@faire/web--source/common/logging";
import { trackSigninSsoErrorError } from "@faire/web-api--source/events/signin/error/ssoError";
import { SocialSignOnProvider } from "@faire/web-api--source/indigofair/data/SocialSignOnProvider";
import React, { useCallback, useEffect } from "react";
var PROVIDER = SocialSignOnProvider.APPLE;
var LISTENER_PREFIX = "AppleIDSignInOn";
var SUCCESS = "Success";
var FAILURE = "Failure";
export var AppleLoginButton = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var _useScriptCheck = useScriptCheck({
        isScriptLoaded: isAppleLoginInitialized,
        loadScript: function() {
            return initializeAppleLogin(setSSOLocalizedErrorMessage);
        },
        provider: PROVIDER
    }), isScriptLoading = _useScriptCheck.isScriptLoading, hasScriptError = _useScriptCheck.hasScriptError;
    var isOnSignIn = props.isOnSignIn, sourceId = props.sourceId;
    var handleSSOSuccess = useHandleSSOSuccess(_object_spread_props(_object_spread({}, props), {
        provider: PROVIDER
    }));
    var _useSSOErrorStore = useSSOErrorStore(), errorMessage = _useSSOErrorStore.errorMessage, setSSOLocalizedErrorMessage = _useSSOErrorStore.setLocalizedErrorMessage, setErrorMessage = _useSSOErrorStore.setErrorMessage, resetErrorMessage = _useSSOErrorStore.resetErrorMessage;
    var _useSSOStore = useSSOStore(), recordSSOButtonClick = _useSSOStore.recordSSOButtonClick, userClickedSSOButton = _useSSOStore.userClickedSSOButton;
    var onSuccess = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(event) {
            var response, _response_authorization_id_token, id_token;
            return _ts_generator(this, function(_state) {
                response = event.detail;
                id_token = (_response_authorization_id_token = response === null || response === void 0 ? void 0 : response.authorization.id_token) !== null && _response_authorization_id_token !== void 0 ? _response_authorization_id_token : "";
                handleSSOSuccess(id_token, response === null || response === void 0 ? void 0 : response.user);
                return [
                    2
                ];
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        handleSSOSuccess
    ]);
    var onFailure = useCallback(function(event) {
        var response = event.detail;
        logError(response, {
            tags: {
                signInType: "SSO",
                provider: PROVIDER,
                code: response === null || response === void 0 ? void 0 : response.error
            }
        });
        var _response_error;
        var code = (_response_error = response === null || response === void 0 ? void 0 : response.error) !== null && _response_error !== void 0 ? _response_error : "";
        var errorMessage = extractMessage({
            provider: PROVIDER,
            code: code
        }, strictLocalize);
        setErrorMessage(errorMessage);
        trackSigninSsoErrorError(PROVIDER, sourceId);
    }, [
        setErrorMessage,
        sourceId,
        strictLocalize
    ]);
    useEffect(function() {
        try {
            getDocumentOrThrow().addEventListener("".concat(LISTENER_PREFIX).concat(SUCCESS), onSuccess);
            getDocumentOrThrow().addEventListener("".concat(LISTENER_PREFIX).concat(FAILURE), onFailure);
        } catch (error) {
            logError(error, {
                tags: {
                    signInType: "SSO",
                    provider: PROVIDER,
                    code: "dom_function_injection_failed"
                }
            });
        }
        return function() {
            try {
                getDocumentOrThrow().removeEventListener("".concat(LISTENER_PREFIX).concat(SUCCESS), onSuccess);
                getDocumentOrThrow().removeEventListener("".concat(LISTENER_PREFIX).concat(FAILURE), onFailure);
            } catch (e) {
                logError(e);
            }
        };
    }, [
        onFailure,
        onSuccess
    ]);
    if (hasScriptError) {
        return /*#__PURE__*/ _jsx(BaseSocialLoginButton, {
            onClick: function() {
                return setErrorMessage(strictLocalize({
                    id: "3Kc3T+",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Apple script is blocked. Unblock and refresh to use Apple sign in."
                        }
                    ]
                }));
            },
            socialProvider: PROVIDER,
            isOnSignIn: isOnSignIn,
            sourceId: sourceId
        });
    }
    if (!userClickedSSOButton && errorMessage) {
        return /*#__PURE__*/ _jsx(BaseSocialLoginButton, {
            onClick: recordSSOButtonClick,
            socialProvider: PROVIDER,
            isOnSignIn: isOnSignIn,
            sourceId: sourceId
        });
    }
    var onClick = function() {
        try {
            var _windowObj_AppleID, _windowObj_AppleID1;
            if (errorMessage) {
                resetErrorMessage();
            }
            var windowObj = getWindowOrThrow();
            if (!isScriptLoading && (windowObj === null || windowObj === void 0 ? void 0 : (_windowObj_AppleID = windowObj.AppleID) === null || _windowObj_AppleID === void 0 ? void 0 : _windowObj_AppleID.auth) && typeof (windowObj === null || windowObj === void 0 ? void 0 : (_windowObj_AppleID1 = windowObj.AppleID) === null || _windowObj_AppleID1 === void 0 ? void 0 : _windowObj_AppleID1.auth.signIn) === "function") {
                AppleID.auth.signIn();
            }
        } catch (error) {
            logError(error, {
                tags: {
                    signInType: "SSO",
                    provider: PROVIDER,
                    code: "auth_signIn_failed"
                }
            });
        }
    };
    return /*#__PURE__*/ _jsx(BaseSocialLoginButton, {
        disabled: props.disabled,
        onClick: onClick,
        socialProvider: PROVIDER,
        loading: isScriptLoading,
        isOnSignIn: isOnSignIn,
        sourceId: sourceId
    });
};
